import { render, staticRenderFns } from "./ShibouDoukishoReasonCard.vue?vue&type=template&id=522942c1&scoped=true"
import script from "./ShibouDoukishoReasonCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShibouDoukishoReasonCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShibouDoukishoReasonCard.vue?vue&type=style&index=0&id=522942c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522942c1",
  null
  
)

export default component.exports